import React from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import { message, Spin } from "antd";
import { clearAccountInfo } from "@utils/auth";
//语言切换
import intl from "react-intl-universal";

const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  timeout: 1000000,
  withCredentials: true, // 允许携带cookie
});

console.log(
  `当前环境${process.env.NODE_ENV}；, 当前接口域名：${process.env.REACT_APP_BASE_URL}, 老系统地址${process.env.REACT_APP_Header}`
);

// 当前正在请求的数量
let requestCount = 0;

// 显示loading
function showLoading() {
  if (requestCount === 0) {
    var dom = document.createElement("div");
    dom.setAttribute("id", "loading");
    document.body.appendChild(dom);
    ReactDOM.render(
      <Spin
        tip={intl.get("Loading_910b61fe-7e7f-2b70-a5ae-97e743818378")}
        size="large"
      />,
      dom
    );
  }
  requestCount++;
}

// 隐藏loading
function hideLoading() {
  requestCount--;
  if (requestCount === 0) {
    document.body.removeChild(document.getElementById("loading"));
  }
}

// 设置axios拦截器：请求拦截器
instance.interceptors.request.use(
  (config) => {
    //请求拦截一般会有哪些操作
    // 1.比如config中的一些信息不符合服务器的要求,这里可以做一些修改
    // 2.比如每次发送网络请求时,都希望在界面中显示一个请求的图标(然后再响应拦截中取消显示)
    // 3.某些网络请求必须携带一些特殊的信息(如登录token),如果没有携带就可以拦截并作响应提示

    // 给请求头添加token
    /*
     * 其中   /.*csrftoken=([^;.]*).*$/    是一个正则表达式，用于从cookie中获取csrftoken的值 ，
     * ([^;.]*) 是命名捕获，表示从匹配到的内容中 只获得 ()内的值。
     * string.match(regex) 得到的是一个数组， 第0项是匹配到的全部内容，第1项是通过命名捕获得到的内容，在这里就是csrftoken的值。
     * 这样就完成了使用axios发送请求的正确配置了，同时保证了网站免受csrf攻击的影响.
     */
    config.headers["X-Requested-With"] = "XMLHttpRequest";

    config.headers["dots-token"] = localStorage.getItem("dots-token") || sessionStorage.getItem("dots-token") || "";

    //中文（默认值，不传，或者是传递错误，展示中文提示）
    config.headers["Accept-Language"] =
      localStorage.getItem("language_type")?.split("_")?.join("-") || "zh-CN";
    if (config.url === "/dpps-service/parse") {
      config.timeout = 0;
    }
    //支持多点登录
    if (config.url === "/api/dots-platform/login") {
      const href = window.location.href;
      if (href.indexOf("dots-api") > -1) {
        const apiValue = href.substring(href.indexOf("dots-api") + 9, href.indexOf("&redirect") !== -1 ? href.indexOf("&redirect") : href.length);
        config.headers["dots-api"] = apiValue;
      }
    }
    // if (config.url === "/api/dots-platform/login") {
    //   config.headers["content-type"] = "application/x-www-form-urlencoded";
    // } else if (config.method == "delete") {
    //   config.headers["content-type"] = "application/json";
    // }
    if (config.url.indexOf('/storage/upload') > -1) {
      config.headers["content-type"] = "multipart/form-data";
    }

    // if (config.url.indexOf("/api/auth-sign-java/address") == -1) {
    //   showLoading();
        // }
    if (config.url.indexOf('dots-collector-factory/data-packet') === -1) {
        showLoading();
    }
    // if (config.url.indexOf("/savePracticePaper") === -1 && config.url.indexOf("/getTeamList") === -1 && config.url.indexOf('dots-collector-factory/data-packet') === -1) {
    // }
    return config;
  },
  (err) => {
    // 请求未成功发出，如：没有网络...
    hideLoading();
    return Promise.reject(err);
  }
);

// 设置axios拦截器: 响应拦截器
instance.interceptors.response.use(
  (res) => {
    // if (res.config.url.indexOf("/api/auth-sign-java/address") == -1) {
    //   hideLoading();
    // }
    if (res.config.url.indexOf('dots-collector-factory/data-packet') === -1) {
        hideLoading();
    }
    if (
      res.config.url === "/api/dots-platform/login" ||
      res.config.url.indexOf("/api/dots-platform/loginAccount/choice") !== -1 ||
      res.config.url.indexOf("/api/dots-platform/team/activateAccount") !== -1
    ) {
      // sessionStorage.setItem(
      //   "dots-token",
      //   res.headers["dots-token"] ? res.headers["dots-token"] : ""
      // );
      const token = res.headers["dots-token"] ? res.headers["dots-token"] : "";
      localStorage.setItem("dots-token", token);
      const date = new Date("Fri, 31 Dec 9999 23:59:59 GMT");
      document.cookie = "dots-token=" + token + "; expires=" + date.toUTCString() + ";path=/;domain=.dataoceanai.com";
    }

    // 失败响应的拦截
    if (res.data) {
      // 失败响应的status需要在response中获得
      switch (res.data.code) {
        // 对得到的状态码的处理，具体的设置视自己的情况而定
        case 400:
          message.error({
            content: res.data.message,
            style: { whiteSpace: 'pre-line' },
          });
          break;
        case 401:
          setTimeout(() => {
            clearAccountInfo();
            window.location.href = `/login`;
          }, 500);
          break;
        case 404:
          message.error("接口地址错误");
          setTimeout(() => {
            clearAccountInfo();
            window.location.href = `/login`;
          }, 500);
          break;
        case 405:
          setTimeout(() => {
            clearAccountInfo();
            window.location.href = `/login`;
          }, 500);
          break;
        // case ...
        case 500:
          message.error(res.data.message);
          return;
        default:
          break;
      }
    }

    // 成功响应的拦截
    return Promise.resolve(res.data);
  },
  (err) => {
    hideLoading();
    console.log(err, err.code, err.message);
    console.log(err.message);

    // 判断超时
    if (
      err.code === "ECONNABORTED" ||
      err.message === "Network Error" ||
      err.message.includes("timeout")
    ) {
      message.error("请求超时，请检查网络！");
    } else {
      message.error("未知错误");
    }

    // 失败响应的拦截
    if (err.response) {
      // 失败响应的status需要在response中获得
      switch (err.response.status) {
        // 对得到的状态码的处理，具体的设置视自己的情况而定
        case 401:
          window.location.href = "/login";
          break;
        case 404:
          window.location.href = "/";
          break;
        case 405:
          break;
        // case ...
        default:
          break;
      }
    }
    // 注意这里应该return promise.reject(),
    // 因为如果直接return err则在调用此实例时，响应失败了也会进入then(res=>{})而不是reject或catch方法
    return Promise.reject(err);
  }
);

/**
 * get请求
 * @param {*} url 请求地址
 * @param {*} params URL参数
 * @returns
 */
export function get(url, params, config) {
  return instance.get(url, {
    ...config,
    params,
  });
}

/**
 * post请求
 * @param {*} url 请求地址
 * @param {*} data 数据
 * @returns
 */
export function post(url, data, config) {
  return instance.post(url, data, config);
}

export function put(url, data) {
  return instance.put(url, data);
}

export function del(url, data) {
  return instance.delete(url, data);
}

export function patch(url, data) {
  return instance.patch(url, data);
}
